import type { Route } from "@/enums/route";

const LOCALE_PATTERN = /^[a-z]{2}(-[A-Z]{2})?$/;

/**
 * The route segments of a pathname, without an optional locale prefix
 * (next-intl `localePrefix: "as-needed"`). The dashboard is `[]`.
 */
export function getRouteSegments(pathname: string): string[] {
  const segments = pathname.split("/").filter(Boolean);
  const [first = ""] = segments;
  return LOCALE_PATTERN.test(first) ? segments.slice(1) : segments;
}

/**
 * True when `pathname` is `route` or below it, compared whole segment by
 * whole segment from the start: `/payees` is not under `/pay`, and a route
 * word deeper in the path never counts. The dashboard (`/`) matches only
 * itself.
 */
export function isRouteActive(pathname: string, route: Route): boolean {
  const path = getRouteSegments(pathname);
  const target = getRouteSegments(route);
  if (target.length === 0) return path.length === 0;
  return target.every((segment, index) => path[index] === segment);
}
